import { useEffect, useState } from 'react';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { eliminateDuplicateLatLng, groupListingsByNearbyPosition } from '../SearchMap.helpers.js';
import { getListingsById } from '../../../ducks/marketplaceData.duck';

const { UUID } = sdkTypes;
/**
 * Custom hook to manage map listings based on zoom level and listing IDs.
 * @param {{searchMapListingIdsStr: string, zoom: number, entities: any, zoomThreshold: number}} param0
 * @returns
 */
export const useMapListings = ({ searchMapListingIdsStr, zoom, entities, zoomThreshold }) => {
    const [listings, setListings] = useState([]);

    useEffect(() => {
        if (!searchMapListingIdsStr) {
            setListings([]);
            return;
        }

        const searchMapListingIds = searchMapListingIdsStr.split(',').map(id => new UUID(id));
        const mapListings = getListingsById({ marketplaceData: { entities } }, searchMapListingIds);

        if (zoom < zoomThreshold) {
            setListings(groupListingsByNearbyPosition(mapListings, zoom));
            return;
        }

        const { listings: nextListings } = mapListings.reduce(eliminateDuplicateLatLng, {
            dictionary: {},
            listings: [],
        });

        setListings(nextListings);
    }, [entities, searchMapListingIdsStr, zoom, zoomThreshold]);

    return listings;
};
